var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-alipay',
                        view: publicPath + 'sprite.svg#view-icon-alipay',
                        viewBox: '0 0 66 18',
                        title: 'Group 21',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };